import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RadioComponentDef } from '@df/ui/form/radio/radio.component.def';
@Component({
    selector: 'radio3',
    templateUrl: './radio3.html',
    styleUrls: ['radio3.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass]
})
export class Radio3Component extends RadioComponentDef {}
